import { render } from "./ModalWaterMeters.vue?vue&type=template&id=562af662"
import script from "./ModalWaterMeters.vue?vue&type=script&lang=js"
export * from "./ModalWaterMeters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__